// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2LBvo","errorLogs":"styles_errorLogs__1l2lC"};